import { Row, Col } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import {
  getCustomIncomeDetails,
  getIncomeForEffortRate,
  haveValue,
  showTickOnDoc,
} from "../../helper/common";
import { useContext, useEffect, useState } from "react";
import TenantContext from "../../context/tenant/TenantContext";
import Arrow from "../../assets/img/dark-arrow.svg";
import moment from "moment";
const CandidateSummary = ({
  user,
  index,
  income_selection,
  setLocalLoading,
}) => {
  const { _t } = useTranslator();
  const { fetchTenantDocs } = useContext(TenantContext);
  const [gurantorDocs, setGurantorDocs] = useState({});

  const getIncome = (_user, incomeSource) => {
    return getCustomIncomeDetails(_user, null, _t, incomeSource);
  };

  const getTenantData = getIncome(user, income_selection?.tenant_source);

  useEffect(() => {
    if (Array.isArray(user?.gurantor_id) && user?.gurantor_id.length) {
      user?.gurantor_id.forEach((guarantor) => {
        fetchFileData(guarantor?._id ?? guarantor);
      });
    }
  }, [user]);

  const fetchFileData = async (user_id) => {
    const res = await fetchTenantDocs(user_id, false);
    const tenantDocsData = res.data.success_res.tenantDocs;
    // console.log(res.data.success_res.tenantDocs, "IN THIS FUNCTION");
    if (Array.isArray(tenantDocsData) && tenantDocsData.length >= 1) {
      const temp_arr = new Map();
      tenantDocsData.map((docs) => {
        temp_arr.set(docs?.type + (docs?.year ? docs?.year : ""), docs);
      });

      setGurantorDocs((prevDocs) => ({
        ...prevDocs,
        [user_id]: Array.from(temp_arr.values()),
      }));
    }
  };

  return (
    <>
      <div className="cand-tile-content border-bottom-cand-summ">
        <div>
          <div className="d-flex justify-content-between">
            <div>
              <div className="d-flex align-items-center">
                <img src={Arrow} alt="Arrow" />
                <h5 className="cand-sub-head">
                  {user?.onfido_user_kyc?.onfido_doc_data?.first_name ? (
                    <span>
                      {`${user?.onfido_user_kyc?.onfido_doc_data?.first_name} ${user?.onfido_user_kyc?.onfido_doc_data?.last_name}`}
                    </span>
                  ) : user?.fname ? (
                    <span>{`${user?.fname} ${user?.lname}`}</span>
                  ) : (
                    <span>N/A</span>
                  )}{" "}
                  <span className="candidateText">
                    {_t("candidate")} {index}
                  </span>
                </h5>
              </div>
              <div className="normal-text cand-doc-number">
                {_t("documents")} :{" "}
                <span className="doc-number">
                  {user?.doc_data?.length ?? 0}
                </span>
              </div>
            </div>
            <div className="d-flex align-items-end">
              <span className="cand-sub-head">
                {_t("income")} : {getTenantData?.amount}€
              </span>
              <span className="source-text sourceText">
                {_t("source")}: {getTenantData?.method}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              {Array.isArray(user?.doc_data) &&
                user?.doc_data.slice(0, Math.ceil(user?.doc_data.length / 2))
                  .length > 0 && (
                  <ul className="d-md-flex align-items-start flex-wrap cand-doc-list">
                    {Array.isArray(user?.doc_data) &&
                      user?.doc_data
                        .slice(0, Math.ceil(user?.doc_data.length / 2))
                        ?.map((doc, index) => (
                          <li
                            className="normal-text col-md-12"
                            style={{
                              background: index % 2 !== 0 ? "#F6F6F6" : "",
                            }}
                          >
                            <span className="d-flex align-items-center">
                              <span class="green-circle-icon">
                                <img
                                  class="dark-doc-icon"
                                  src="/images/dark-document.svg"
                                  alt=""
                                />
                              </span>
                              <span>{_t(doc?.type, "", "fixed")}</span>
                            </span>
                            <span>
                              <span
                                className={`date ${
                                  !showTickOnDoc(doc, user)
                                    ? "image-not-available"
                                    : ""
                                }`}
                              >
                                {_t("uploadedOn")}
                                {": "}
                                {moment(doc?.created_at).format("DD/MM/YYYY")}
                              </span>
                              {showTickOnDoc(doc, user) && (
                                <img src="/images/tick-new.svg" alt="" />
                              )}
                            </span>
                          </li>
                        ))}
                  </ul>
                )}
            </div>
            <div className="col-md-6">
              {Array.isArray(user?.doc_data) &&
                user?.doc_data.slice(
                  Math.ceil(user?.doc_data.length / 2),
                  user?.doc_data.length
                ).length > 0 && (
                  <ul className="d-md-flex align-items-start flex-wrap cand-doc-list">
                    {Array.isArray(user?.doc_data) &&
                      user?.doc_data
                        .slice(
                          Math.ceil(user?.doc_data.length / 2),
                          user?.doc_data.length
                        )
                        ?.map((doc, index) => (
                          <li
                            className="normal-text col-md-12"
                            style={{
                              background: index % 2 !== 0 ? "#F6F6F6" : "",
                            }}
                          >
                            <span className="d-flex align-items-center">
                              <span class="green-circle-icon">
                                <img
                                  class="dark-doc-icon"
                                  src="/images/dark-document.svg"
                                  alt=""
                                />
                              </span>
                              <span>{_t(doc?.type, "", "fixed")}</span>
                            </span>
                            <span>
                              <span
                                className={`date ${
                                  !showTickOnDoc(doc, user)
                                    ? "image-not-available"
                                    : ""
                                }`}
                              >
                                {_t("uploadedOn")}
                                {": "}
                                {moment(doc?.created_at).format("DD/MM/YYYY")}
                              </span>
                              {showTickOnDoc(doc, user) && (
                                <img src="/images/tick-new.svg" alt="" />
                              )}
                            </span>
                          </li>
                        ))}
                  </ul>
                )}
            </div>
          </div>
        </div>
        <Row>
          {Array.isArray(user?.gurantor_id) &&
            user?.gurantor_id.map((guarantor, index) => {
              const docs = gurantorDocs[guarantor?._id] ?? [];

              const getIncomeData = getIncome(
                guarantor,
                income_selection?.guarantor_sources?.[guarantor?._id]
              );

              return (
                <Col xl={12}>
                  <div className="cand-orange-content">
                    <div className="d-md-flex justify-content-between">
                      <div className="">
                        <p className="cand-orange-text">
                          {`${guarantor?.fname ?? ""} ${guarantor?.lname}`}
                          <span className="candidateTextGuarantor">
                            {" "}
                            {_t("guarantor")} {index + 1}
                          </span>
                        </p>
                        {/* <p className="source-text">
                          {_t("guarantorRelation")}:{" "}
                          {_t(guarantor?.gurantor_relation)}
                        </p> */}
                      </div>
                      <div className="d-flex align-items-end">
                        <p className="cand-sub-head">
                          {_t("income")} : {getIncomeData?.amount}€
                        </p>
                        <p className="source-text sourceText">
                          {_t("source")}: {getIncomeData?.method}
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="normal-text cand-doc-number">
                        {_t("documents")} :{" "}
                        <span className="doc-number">{docs?.length ?? 0}</span>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          {Array.isArray(docs) &&
                            docs.slice(0, Math.ceil(docs.length / 2)).length >
                              0 && (
                              <ul className="d-md-flex align-items-start flex-wrap cand-doc-list">
                                {Array.isArray(docs) &&
                                  docs
                                    .slice(0, Math.ceil(docs.length / 2))
                                    ?.map((doc, index) => (
                                      <li
                                        className="normal-text col-md-12"
                                        style={{
                                          background:
                                            index % 2 !== 0 ? "#FFEFE5" : "",
                                        }}
                                      >
                                        <span className="d-flex align-items-center">
                                          <span class="green-circle-icon">
                                            <img
                                              class="dark-doc-icon"
                                              src="/images/dark-document.svg"
                                              alt=""
                                            />
                                          </span>
                                          <span>
                                            {_t(doc?.type, "", "fixed")}
                                          </span>
                                        </span>
                                        <span>
                                          <span
                                            className={`date ${
                                              !showTickOnDoc(doc, guarantor)
                                                ? "image-not-available"
                                                : ""
                                            }`}
                                          >
                                            {_t("uploadedOn")}
                                            {": "}
                                            {moment(doc?.created_at).format(
                                              "DD/MM/YYYY"
                                            )}
                                          </span>
                                          {showTickOnDoc(doc, guarantor) && (
                                            <img
                                              src="/images/tick-new.svg"
                                              alt=""
                                            />
                                          )}
                                        </span>
                                      </li>
                                    ))}
                              </ul>
                            )}
                        </div>
                        {Array.isArray(docs) &&
                          docs.slice(Math.ceil(docs.length / 2), docs.length)
                            .length > 0 && (
                            <div className="col-md-6">
                              <ul className="d-md-flex align-items-start flex-wrap cand-doc-list">
                                {Array.isArray(docs) &&
                                  docs
                                    .slice(
                                      Math.ceil(docs.length / 2),
                                      docs.length
                                    )
                                    ?.map((doc, index) => (
                                      <li
                                        className="normal-text col-md-12"
                                        style={{
                                          background:
                                            index % 2 !== 0 ? "#FFEFE5" : "",
                                        }}
                                      >
                                        <span className="d-flex align-items-center">
                                          <span class="green-circle-icon">
                                            <img
                                              class="dark-doc-icon"
                                              src="/images/dark-document.svg"
                                              alt=""
                                            />
                                          </span>
                                          <span>
                                            {_t(doc?.type, "", "fixed")}
                                          </span>
                                        </span>
                                        <span>
                                          <span
                                            className={`date ${
                                              !showTickOnDoc(doc, guarantor)
                                                ? "image-not-available"
                                                : ""
                                            }`}
                                          >
                                            {_t("uploadedOn")}
                                            {": "}
                                            {moment(doc?.created_at).format(
                                              "DD/MM/YYYY"
                                            )}
                                          </span>
                                          {showTickOnDoc(doc, guarantor) && (
                                            <img
                                              src="/images/tick-new.svg"
                                              alt=""
                                            />
                                          )}
                                        </span>
                                      </li>
                                    ))}
                              </ul>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
        </Row>
      </div>
    </>
  );
};

export default CandidateSummary;
